import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";
import { epdSearchStore } from "store/Mapping/EPDSearchStore";
import FiltersMenu, { DropdownOption } from "./FiltersMenu";

const EPDFilter = () => {
  const { t } = useTranslation();
  const wrapperRef = React.useRef<HTMLDivElement>(null);
  const [categories, setCategories] = React.useState<DropdownOption[]>([]);

  React.useEffect(() => {
    getFilterCategories();
  }, []);

  const getFilterCategories = async () => {
    const categories = await epdSearchStore.fetch2050FilterCategories();
    const categoriesList = categories?.map((rec) => ({
      id: rec.id,
      name: rec.category_name,
      name_de: rec.category_name_de,
      value: rec.category_key,
      hasChildren: true,
    }));
    categoriesList && setCategories(categoriesList);
  };

  const getFilterOptions = async (
    id: string,
    searchTerm: string,
    pageNumber: number,
    pageSize: number
  ) => {
    const response = await epdSearchStore.fetch2050FilterChildren(
      String(id),
      searchTerm,
      pageNumber,
      pageSize
    );
    const options =
      response.items?.map(
        (item) =>
          ({
            id: item.option_id,
            name: item.option_name,
            name_de: item.option_name_de,
            hasChildren: false,
            badge: item.badge,
          } as DropdownOption)
      ) ?? [];
    const updatedItems = {
      count: response.count,
      items: options,
    };
    return updatedItems;
  };

  if (categories.length === 0) return;
  return (
    <div id="filter-wrapper" ref={wrapperRef} className="relative">
      <FiltersMenu
        wrapperID="filter-wrapper"
        options={categories}
        fetchChildren={getFilterOptions}
        pageSize={25}
        onSelectItem={(items) => epdSearchStore.setSelectedFilters(items)}
        checkedItems={epdSearchStore.selectedFilters}
        noResultText={t("productEditor.noFilterOptionText")}
        disabled={epdSearchStore.fetchingEPDsLoading}
        singleSelect
      />
    </div>
  );
};

export default observer(EPDFilter);
